export interface MixStop {
	color: string;
	weight: number;
}

function mixColor(from: string, to: string, weight: number) {
	return `color-mix(in oklch, ${from} ${weight}%, ${to} ${100 - weight}%)`;
}

function mix<S extends Record<number, MixStop>>(base: string, mixer: string, stops: S) {
	const result: Record<keyof S, string> = {} as Record<keyof S, string>;

	for (const key in stops) {
		result[key] = mixColor(base, mixer, stops[key]!.weight);
	}

	return result;
}

export function mixSimplePaletteColor(base: string, lightMixer: string, darkMixer: string) {
	const lightStops = {
		50: { color: lightMixer, weight: 8 },
		100: { color: lightMixer, weight: 15 },
		200: { color: lightMixer, weight: 30 },
		300: { color: lightMixer, weight: 50 },
		400: { color: lightMixer, weight: 75 },
	};

	const darkStops = {
		600: { color: darkMixer, weight: 85 },
		700: { color: darkMixer, weight: 75 },
		800: { color: darkMixer, weight: 65 },
		900: { color: darkMixer, weight: 50 },
		950: { color: darkMixer, weight: 30 },
	};

	return {
		...mix(base, lightMixer, lightStops),
		500: base,
		...mix(base, darkMixer, darkStops),
	};
}

export function mixNeutralPaletteColor(base: string, additionalStops: Record<number, MixStop | MixStop[]>) {
	const stops = {
		50: 2,
		100: 6,
		200: 12,
		300: 18,
		400: 40,
		500: 50,
		600: 64,
		700: 76,
		800: 86,
		850: 90,
		900: 92,
		950: 100,
	};

	const result = {} as Record<keyof typeof stops, string>;

	for (const [stop, weight] of Object.entries(stops)) {
		let color = mixColor(base, '#ffffff', weight);

		const additionalStop = additionalStops[stop as unknown as number] ?? [];
		const additions = Array.isArray(additionalStop) ? additionalStop : [additionalStop];

		for (const additionalStop of additions) {
			color = mixColor(color, additionalStop.color, 100 - additionalStop.weight);
		}

		result[stop as unknown as keyof typeof stops] = color;
	}

	return result;
}
